import { InjectionToken } from '@angular/core';

export const DATE_FORMAT = {
    parse: {
      dateInput: 'LL',
    },
    display: {
      dateInput: 'LL',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
    },
};

export const MAIN_API = 'https://localhost:7139/';
export const SPINNER_TEMPLATE = "<img src='assets/images/logos/mv_logo_100-100.gif'/>";

export enum AppId { GLOBAL = 'global', CLIENT = 'client', SUPPLIER = 'supplier', SIGA = 'siga' }
export const IS_APP_ID = new InjectionToken<AppId>('IS_APP_ID');
